import {
  fetchGetNewRecommendedOffers,
  TGetNewRecommendedOffersRequest,
} from '../repositories/search-engine/v1/get-new-recommended-offers';
import {
  fetchGetOffersFromHistory,
  TGetOffersFromHistoryResponse,
} from '../repositories/search-engine/v1/get-offers-from-history';
import {
  TGetRecommendedOffersRequest,
  TGetRecommendedOffersResponse,
  fetchGetRecommendedOffers,
} from '../repositories/search-engine/v3/get-recommended-offers';
import {
  TGetSimilarOffersRequest,
  TGetSimilarOffersResponse,
  fetchGetSimilarOffers,
} from '../repositories/search-engine/v3/get-similar-offers';
import { IApplicationContext } from '../types/applicationContext';

export function getItemBasedSimilarOffers(
  { httpApi }: IApplicationContext,
  parameters: TGetSimilarOffersRequest,
): Promise<TGetSimilarOffersResponse> {
  return fetchGetSimilarOffers({
    httpApi,
    parameters,
    config: {},
  });
}

export function getUserBasedSimilarOffers(
  { httpApi }: IApplicationContext,
  parameters: TGetRecommendedOffersRequest,
): Promise<TGetRecommendedOffersResponse> {
  return fetchGetRecommendedOffers({
    httpApi,
    parameters,
    config: {},
  });
}

export function getHistoryBasedSimilarOffers({ httpApi }: IApplicationContext): Promise<TGetOffersFromHistoryResponse> {
  return fetchGetOffersFromHistory({
    httpApi,
    config: {},
    parameters: {},
  });
}

export function getNewItemBasedSimilarOffers(
  { httpApi }: IApplicationContext,
  parameters: TGetNewRecommendedOffersRequest,
): Promise<TGetOffersFromHistoryResponse> {
  return fetchGetNewRecommendedOffers({
    httpApi,
    parameters,
    config: {},
  });
}
